package org.hs_soft.runmynesto.pages.home.sub_page.product.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.GetProduct
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.FilterRow
import org.hs_soft.runmynesto.pages.components.grid_function.FilterActiveGridContent
import org.hs_soft.runmynesto.pages.components.grid_function.GridFunction
import org.hs_soft.runmynesto.pages.components.grid_function.GridItemsList

@Composable
fun GridProductBar(
    titleDescending: Boolean,
    numberDescending: Boolean,
    showNumberSortIcon: Boolean,
    showTitleSortIcon: Boolean,
    showFilterComponent:Boolean,
    selectedFilterOption: GridItemsFilterEnum,
    selectedItem: GetProduct?,
    searchValue: String,
    windowSizeMode: WindowSizeModeEnum,
    infoList: List<ProductItem>,
    loading:Boolean,
    onTitleSortClick: () -> Unit,
    onNumberSortClick: () -> Unit,
    onSearchValueChange: (String) -> Unit,
    refreshList: () -> Unit,
    onProductClick: (String) -> Unit,
    onAddRecord: () -> Unit,
    onFilterComponentClick:()->Unit,
    selectFilterType:(GridItemsFilterEnum)->Unit,
    onCloseFilterClick:()->Unit,
    submitFilterItems:()->Unit,
) {

    Column(
        modifier = Modifier
            .thenIf(
                windowSizeMode==WindowSizeModeEnum.PHONE,
                Modifier.fillMaxWidth()
            )
            .fillMaxHeight()
    )
    {
        FilterRow(
            modifier =Modifier,
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            selectedFilterType=selectedFilterOption,
            onAddRecordClick = {
                onAddRecord()
            },
            onFilterClick = {
                onFilterComponentClick()
            }
        )

        Box(
            modifier = Modifier
                .thenIf(
                    windowSizeMode==WindowSizeModeEnum.PHONE,
                    Modifier.fillMaxWidth()
                )
                .weight(1f)
                .margin(top = Dimen.normalPadding)
        )
        {
            if (showFilterComponent){
                FilterActiveGridContent(
                    selectFilterType = {
                        selectFilterType(it)
                    },
                    selectedFilterType=selectedFilterOption,
                    onCloseFilterClick ={
                        onCloseFilterClick()
                    },
                    submitFilterItems = {
                        submitFilterItems()
                    }

                )
            }

            Column(
                modifier = Modifier
                    .thenIf(
                        windowSizeMode==WindowSizeModeEnum.PHONE,
                        Modifier.fillMaxWidth()
                    )
                    .fillMaxHeight()
            ) {
                CustomEditText(
                    label = "",
                    fillMaxWidth =windowSizeMode==WindowSizeModeEnum.PHONE,
                    value = searchValue,
                    width = Dimen.gridWidth,
                    endIconPath = Res.PathIcon.searchBox,
                    isRequired = false,
                    hint = Strings.current().search,
                    onFocusIn = {},
                    onFocusOut = {},
                    onInputChange = {it, validation ->
                        onSearchValueChange(it)
                    },
                )

                GridFunction(
                    modifier = Modifier ,
                    fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                    title = Strings.current().name,
                    loading=loading,
                    infoTitle = Strings.current().numberDot,
                    footerTitle = Strings.current().products,
                    infoList = infoList,
                    titleDescending = titleDescending ,
                    numberDescending = numberDescending,
                    showTitleSortIcon = showTitleSortIcon,
                    showNumberSortIcon = showNumberSortIcon,
                    onTitleSortClick = {
                        onTitleSortClick()
                    },
                    onNumberSortClick = {
                        onNumberSortClick()
                    },
                    refreshList = {
                         refreshList()
                    },
                    content = {
                        GridItemsList(
                            id = selectedItem?.id?:"",
                            items = infoList,
                            onItemClick = {
                                onProductClick(it)
                            },
                        )
                    },

                )
            }
        }




    }
}